<template>
	<div class = "pay-goods-div">
		<van-row v-for = "(item,index) in getGoodsList" :key="index">
		  <van-col span="8">
			  <img class="pay-goods-image" :src="item.thumb"/>
		  </van-col>
		  <van-col span="12">
			  <div class="pay-goods-name">{{item.name}}</div>
			  <div class="pay-goods-specification">{{getSingleSpec(item.specs)}}</div>
			  <div class="pay-goods-price">
				  <span>¥</span>
				  <span>{{getSinglePrice(item)}}</span>
			  </div>
		  </van-col>
		  <van-col span="4">
			  <div class = "pay-goods-count">x{{item.goodsNum}}</div>
		  </van-col>
		</van-row>
		<div class = "divider-div"></div>
		<van-row type="flex" justify="space-between">
		  <van-col span="8"><div class = "pay-save-money">已省：¥{{parseFloat(getOfficalPrice - getPrice).toFixed(2)}}</div></van-col>
		  <van-col span="16">
			  <div class = "pay-money">
				  <span>共一件，实付：</span>
				  <span>¥</span>
				  <span>{{parseFloat(getPrice+'').toFixed(2)}}</span>
				  <span>¥{{parseFloat(getOfficalPrice+'').toFixed(2)}}</span>
			  </div>
		  </van-col>
		</van-row>
	</div>
		
</template>

<script>
	    import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
		import {Col, Row} from 'vant';
		export default {
			name: 'PayGoods',
			computed: mapGetters(["getGoodsList","getPrice","getOfficalPrice"]),
			components: {
			      [Col.name]: Col,
			      [Row.name]: Row
			      
			 },
			data(){
				return {
				}
			},
			methods:{
				getSinglePrice(item){
					// console.log(item);
					let price = item.price
					if(item.specs){
						for(let spec of item.specs){
							if(spec.upPrice){
								price += spec.upPrice
							}
						}
					}
					price = parseFloat(price).toFixed(2)
					return price
				},
				getSingleSpec(specs){
					let specText = ''
					if(specs){
						for(let spec of specs){
							if(specText){
								specText = specText + "/";
							}
							specText = specText + spec.itemName;
						}
					}
					return specText;
				},
			}
		}
</script>

<style scoped>
	.pay-goods-div {
		border-radius: 5px;
		padding: 10px;
		background-color: #ffffff;
	}
	
	
	.pay-goods-image {
		width: 90px;
		height: 90px;
		display: block;
		margin: 0 auto;
	}
	
	.pay-goods-name {
		padding-bottom: 5px;
		color: #343434;
		font-size: 17px;
		font-weight: 650;
	}
	.pay-goods-specification {
		padding-bottom: 3px;
		color: #656565;
		font: 14px;
	}
	
	.pay-goods-price>span:first-child {
		color: #c8544a;
		font-size: 14px;
		font-weight: 570;
	}
	.pay-goods-price>span:last-child {
		color: #c8544a;
		font-size: 16px;
		font-weight: 570;
	}
	
	.divider-div {
		width: 100%;
		height: 1px;
		border-top: #dedede 1px dashed;
		padding: 5px;
	}
	
	.pay-goods-count {
		font-size: 15px;
		color: #343434;
		text-align: center;
		padding-top: 30px;
		font-weight: 600;
		
	}
	
	.pay-save-money {
		font-size: 15px;
		color: #414141;
		font-weight: 500;
		padding-left: 5px;
	}
	.pay-money {
		padding-right: 5px;
		text-align: right;
	}
	.pay-money>span:nth-child(1) {
		font-size: 15px;
		color: #414141;
		font-weight: 500;
	}
	.pay-money>span:nth-child(2) {
		font-size: 13px;
		color: #cf4645;
		font-weight: 550;
		
	}
	.pay-money>span:nth-child(3) {
		font-size: 16px;
		color: #cf4645;
		font-weight: 550;
		
	}
	.pay-money>span:nth-child(4) {
		font-size: 13px;
		color: #959394;
		text-decoration: line-through;
		margin-left: 3px;
	}
	
</style>
